import { AppBar, Grid, Hidden, Toolbar } from '@material-ui/core';
import { PaddedContent } from 'design-system';
import { useCallback } from 'react';
import { NavigateFunction, useNavigate } from 'react-router-dom';

import {
  makeLogoutButtonMobile,
  mobileAssaLogo,
} from '../../DashboardScreen/DashboardToolbar/mobileViewMethods';

import {
  makeDesktopAssaLogo,
  makeLogoutButtonDesktop,
  makeUserLayoutDesktop,
} from '../../DashboardScreen/DashboardToolbar/desktopViewMethods';

import makeDashboardToolbarStyles from '../../DashboardScreen/DashboardToolbar/makeDashboardToolbarStyles';

export function logOutAndRedirect(
  isBackToAssaNet: boolean,
  onLogoutClick: () => void,
  history: NavigateFunction,
): void {
  onLogoutClick();
  if (!isBackToAssaNet) {
    history(`/`);
    window.location.reload();
  }
}

type Props = {
  user: string;
  onLogoutClick: () => void;
};

export const LandingToolbar = ({ user, onLogoutClick }: Props): JSX.Element => {
  const classes = makeDashboardToolbarStyles({ appbarHeight: '46px' });
  const history = useNavigate();

  const handleLogout = useCallback(
    (isBackToAssaNet: boolean): void => {
      logOutAndRedirect(isBackToAssaNet, onLogoutClick, history);
    },
    [onLogoutClick, history],
  );

  return (
    <>
      <AppBar className={classes.appBar} position="fixed">
        <Toolbar className={classes.appBar}>
          {/* Mobile toolbar */}
          <Hidden mdUp>
            <Grid
              container
              spacing={1}
              justifyContent="space-between"
              alignItems="center"
              direction="row"
              className={classes.appBarContent}
            >
              {mobileAssaLogo}
              {makeLogoutButtonMobile(handleLogout, classes, false)}
            </Grid>
          </Hidden>

          {/* Desktop Toolbar */}
          <Hidden smDown>
            <PaddedContent defaultPadding={0} style={{ width: '100%' }}>
              <Grid container style={{ height: '100%' }}>
                <Grid
                  item
                  xs={7}
                  container
                  justifyContent="flex-start"
                  alignItems="center"
                  style={{ flexWrap: 'nowrap' }}
                >
                  {makeDesktopAssaLogo(classes)}
                  {makeUserLayoutDesktop(user, classes, 'Bienvenido')}
                </Grid>
                <Grid
                  item
                  xs={5}
                  container
                  justifyContent="flex-end"
                  alignItems="center"
                  style={{ flexWrap: 'nowrap' }}
                >
                  {makeLogoutButtonDesktop(handleLogout, classes)}
                </Grid>
              </Grid>
            </PaddedContent>
          </Hidden>
        </Toolbar>
      </AppBar>

      {/* Toolbar offset, to prevent elements from rendering behind it */}
      <div className={classes.appBarOffset} />
    </>
  );
};

export default LandingToolbar;
